<template>
  <div>
    <!--Icon-->
    <a
      class="c-black btn btn-outline-orange w-150px"
      :href="'https://www.facebook.com/sharer.php?u=' + urlSite"
      alt="Facebook"
      target="_blank"
    >
      <!--Text-->
      <i class="fab fa-facebook-f fs-25 mr-3"></i>
      Facebook
    </a>
  </div>
</template>

<script>
export default {
  data: () => ({
    //urlSite: window.location.href,
    urlSite: document.URL,
  }),
};
</script>
